module.exports = __webpack_public_path__ + "img/swift.b1a255c.svg";